import type { AxiosPromise } from 'axios';
import BaseClient from '../BaseClient';
import type {
    MembershipStatusDefinitionFormData,
    MembershipStatusDefinitionsClientInterface,
    MembershipStatusDefinitionsResponse,
} from './membershipStatusDefinitionsClient.types';

export default class CorporateMembershipStatusDefinitionsClient
    extends BaseClient
    implements MembershipStatusDefinitionsClientInterface
{
    constructor(private teamId: number) {
        super();
    }

    getMembershipStatusDefinitions(): AxiosPromise<MembershipStatusDefinitionsResponse> {
        const url = `/api/v3/teams/${this.teamId}/membership-status-definitions`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateMembershipStatusDefinitions(
        data: { definitions: MembershipStatusDefinitionFormData[] },
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<MembershipStatusDefinitionsResponse> {
        const url = `/api/v3/teams/${this.teamId}/membership-status-definitions`;
        return this.makeCoreApiRequest(url, 'put', data, null, extraConfig);
    }
}
